import ToolTip from "../../tooltip";

const ModTooltip = ({ preferredLoadInput }) => {
  if (preferredLoadInput !== "drop") return null;

  return (
    <ToolTip
      id="load-mod-tooltip"
      body="A % load modification (%mod.) is a programming tool that allows you to base a load from a previous load used. For example, program a load that is -10% from your top set for that day. Or, program a load that is +5% heavier from the weight your client used in their previous workout with that exercise. See MSB University for more details"
    >
      <span className="load-mod-tooltip">?</span>
    </ToolTip>
  );
};

export default ModTooltip;
